import { ConfirmModal } from "./ConfirmModal";

type Props = {
  name: string | null;
  onClose: () => void;
  onConfirm: (name: string) => void;
};

export function StepTestUnpinConfirmModal({ name, onClose, onConfirm }: Props) {
  return (
    <ConfirmModal
      open={name !== null}
      title="Unpin step test"
      description={`Unpin “${name ?? ""}”? Future checks for this step will no longer replay its input.`}
      confirmLabel="Unpin"
      destructive
      onClose={onClose}
      onConfirm={() => {
        if (name) onConfirm(name);
        onClose();
      }}
    />
  );
}
